export default __webpack_public_path__ + "e067996c82a20ac79646723844b419b9.png";